
import React from 'react'
import Navbar from "../inc/Navbar";
import Slider from '../inc/Slider';
import { Link } from "react-router-dom";
import Logo from "../images/KPS_logo.png";
import nareshchandradas_chairman from "../images/Naresh Chandra Das _Chairman.jpeg";
import mramitavaguha_director from "../images/director.jpeg";
import drsankarprasaddutta_principal from "../images/Dr. Sankar Prasad Dutta_principal.png";
import kps_admissionform from "../images/KPS_e-Admission Form.pdf";
import kpsprospectus from "../images/KPS_prospectus_2025-26.pdf";

import ScrollToTop from "react-scroll-to-top";
import "./Home.css";
import Vgallery from './Vgallery';
import NoticeBoard from './NoticeBoard';
import EventHeld from './EventHeld';
import NewRealites from './NewRealites';

import SafetyFirst from "../images/Safety First.jpg";
import TrainedTeachers from "../images/Trained Teachers.jpg";
import CreativeLessons from "../images/Creative Lessons.jpg";
import SpecialEducation from "../images/Special Education.jpg"
import sports from "../images/sports icon.jpg";
import SufficientClassrooms from "../images/Sufficient Classrooms.jpg";
import Popup from './Popup';



function Home() {
    return (
        <div>
            <Navbar />
            <br />
            <br></br>
            <br />

            <div className="album py-2">
                <div className="container">
                    <h5>KRISHNAGAR PUBLIC SCHOOL</h5>
                </div>
            </div>
           
            <div className="kps">
                <div className="album py-2">
                    <div className="container">
                        <div className="row ">
                            <div className="col-md-2">
                                <center>
                                    <Link to="/">
                                        <img src={Logo} className='mt-3 logokps' width="145px" height="160px" alt="kps logo" />

                                    </Link>

                                </center>
                            </div>
                            <div className="col-md-8">
                                <center>

                                    <h1 style={{ color: "white" }} className='font mb-0 mt-3'><b>KRISHNAGAR PUBLIC SCHOOL</b></h1>
                                    <div className='fonts'>
                                        <p style={{ color: "white" }} className='mb-2'>An ISO 9001: 2015 Certified Organization</p>

                                        <h6 style={{ color: "white" }} className='mb-0' >Affiliated to CBSE, Senior Secondary Level | CBSE Affiliation No 2430223</h6>

                                    </div>

                                </center>
                            </div>


                            <div className="d-flex justify-content-between align-items-center">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Slider />
            <div className='kpsndia'>
                <div className="album py-0">
                    <div className="container">
                        <marquee>
                            <h5 style={{ margin: "2px", }} className='mt-2'>Welcome to <b className='kpsfonts'> Krishnagar Public School, </b> An ISO 9001: 2015 Certified Organization | Affiliated to CBSE, Senior Secondary Level | CBSE Affiliation No 2430223</h5>
                        </marquee>
                    </div>
                </div>
            </div>
            {/* <div style={{ color: "white", padding: "14px;", margin: 10 }} className="fixed-bottom "> <a style={{ color: "white" }} href={kpsprospectus} target="_blank" rel="noopener noreferrer" className="kps_PROSPECTUS" > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-download" viewBox="0 0 16 16">
                <path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383" />
                <path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z" />
            </svg> KPS PROSPECTUS 2025-26      <div className="spinner-grow text-light spinner-grow-sm" role="status">
                    <span className="visually-hidden"> Loading...</span>
                </div> </a></div> */}
            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 mt-3">
                            <div className="card-body">
                                <div className='welcometext'>
                                    <h1 className="card-title"><b>What We Offer</b></h1>
                                </div>
                                <p>We offer best facilities and education to our students through different proven methods of learning and activity. Our infrastructure is the pride of us and our students.</p>

                                <div className="d-flex justify-content-start align-items mb-2">
                                    <div className="card me-2">
                                        <img src={SafetyFirst} className="card-img-top" alt="SafetyFirst" />
                                        <div className="card-body">
                                            <div className='weoffer'>
                                                <h5 className="card-title">Safety First</h5>
                                            </div>
                                            <p className=" card-text">First thing first! We have trained staff, CCTV and our teacher's also monitor students activity all the time almost every where at school premises.</p>

                                        </div>
                                    </div>
                                    <div className="card">
                                        <img src={TrainedTeachers} className="card-img-top" alt="TrainedTeachers" />
                                        <div className="card-body">
                                            <div className='weoffer'>
                                                <h5 className="card-title">Trained Teachers</h5>
                                            </div>
                                            <p className=" card-text">It is true that a well trained teacher can bring out successful students. The teachers of KPS are sent to attend different workshops conducted by CBSE at regular intervals.</p>

                                        </div>
                                    </div>
                                </div>


                                <div className="d-flex justify-content-start align-items mb-2">
                                    <div className="card me-2">
                                        <img src={CreativeLessons} className="card-img-top" alt="CreativeLessons" />
                                        <div className="card-body">
                                            <div className='weoffer'>
                                                <h5 className="card-title">Creative Lessons</h5>
                                            </div>
                                            <p className=" card-text">Our well experienced respected teachers provide lessons to our students through an extensive way where creativeness is unquestionable.</p>

                                        </div>
                                    </div>
                                    <div className="card">
                                        <img src={sports} className="card-img-top" alt="Sports Facilities" />
                                        <div className="card-body">
                                            <div className='weoffer'>
                                                <h5 className="card-title">Sports Facilities</h5>
                                            </div>
                                            <p className=" card-text">Through out the School there is an extensive range of extra-curricular activities that successfully promote pupils' intellectual, aesthetic and physical development.</p>

                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-start align-items mb-2">
                                    <div className="card me-2">
                                        <img src={SpecialEducation} className="card-img-top" alt="SpecialEducation" />
                                        <div className="card-body">
                                            <div className='weoffer'>
                                                <h5 className="card-title">Special Education</h5>
                                            </div>
                                            <p className=" card-text">As per the CBSE guidelines, KPS provides admission and special education to the special and differently abled children.</p>

                                        </div>
                                    </div>
                                    <div className="card">
                                        <img src={SufficientClassrooms} className="card-img-top" alt="Smart Classrooms" />

                                        <div className="card-body">
                                            <div className='weoffer'>
                                                <h5 className="card-title">Smart Classrooms</h5>
                                            </div>
                                            <p className=" card-text">Our tech-enabled smart classrooms bring lessons to life with interactive boards, audio-visual tools and the latest digital resources, making learning immersive and future-ready.</p>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div className="col-md-6 mt-3">
                            <div className='offerpage'>
                                <div className="card-body">
                                    <div className='welcometext'>
                                        <h1 className="card-title mb-3">Welcome to <b>Krishnagar Public School, Nadia!</b></h1>
                                    </div>
                                    <p style={{color:"#1D4D93"}} className='mb-2'>Dear Visitors,</p>
                                    <p>A warm welcome to Krishnagar Public School!</p>

                                    <p className='justify mb-2'>Founded in 2016 through the visionary efforts of Shri Naresh Chandra Das, KPS stands today as a premier co-educational senior secondary school affiliated with the Central Board of Secondary Education (CBSE), New Delhi. With a blend of state-of-the-art infrastructure, a team of committed and experienced educators, and a progressive, child-centric pedagogical approach, we are proud to guide our students confidently into the 21st century.</p>
                                    <p className='justify mb-1'>At KPS, we place our students at the very heart of all that we do. We believe that education must resonate with the learner’s natural curiosity and potential. Children should be taught in ways that align with how they learn best and not forced to fit into a rigid model of teaching. For us, every child is more than a roll number – they are unique individuals, each with their own strengths, dreams, and promise. It is our responsibility to nurture them with care, compassion, and empathy, so they grow into confident, self-aware, and capable human beings. </p>
                                    <p className='justify mb-1'>Our mission is to help every child discover their own unique potential and to support them in translating their abilities into achievements. Rather than just delivering content, we focus on teaching students how to learn, ensuring they grow into lifelong learners, empathetic citizens, and future-ready leaders.</p>
                                    <div className="d-flex justify-content-end align-items-end mb-0">
                                        <a href='aboutus'>
                                            <button className='cbsc_school mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                            </svg></button>
                                        </a>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
            <hr />

             <Popup/>
            <div className='welcome_kps'>
                <br />
                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card-body">
                                    <div className='welcometext'>
                                        <h1 className="card-title"><b>Welcome Address</b></h1>
                                    </div>
                                    <h6>Dear Parents</h6>
                                    <p className='mb-2'>A warm welcome to Krishnagar Public School! </p>
                                    <p className='justify mb-1'>Established in 2016, as a result of the futuristic vision of Shri Naresh Chandra Das, Krishnagar Public School is a co-educational senior secondary school, affiliated to Central Board of Secondary Education, New Delhi with state-of-the-art infrastructure, a dedicated team of trained and experienced teachers and a futuristic pedagogical approach that is custom-made for hand-holding the students into the 21st century world.  </p>
                                    <div className="d-flex justify-content-end align-items-end mb-0">
                                        <a href='welcome'>
                                            <button className='cbsc_school mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                            </svg></button>
                                        </a>
                                    </div>

                                </div>

                            </div>


                        </div>
                    </div>
                </div>
                <br />
            </div>

            <ScrollToTop smooth top="100" color="#2C3876" />

            <div className='school'>
                <br />
                <br />
                <div className="album py-1">
                    <div className="container">
                        <div className="card mb-3" >
                            <div className="row g-0">
                                <div className="col-md-4">
                                    <img src={nareshchandradas_chairman} height="150px" width="150px" className="img-fluid  rounded-start" alt="nareshchandradas_chairman" />
                                </div>
                                <div className="col-md-8">
                                    <div className="card-body">
                                        <div className='welcometext'>
                                            <h5 className="card-title"><b>Message from the Chairman</b> </h5>

                                            <p className="card-text justify">We are glad that you are considering Krishnagar Public School for your child's future. Education is the basis of all progress and an education of the highest quality is the greatest gift that parents can give to their children. </p>
                                            <p className="card-text"><small className="text-muted mb-3">The entire purpose of education is not only to restrict itself to imparting bookish knowledge, but to inculcate humanitarian values like wisdom, compassion, courage, humility, integrity and reliability in a student</small></p>
                                        </div>
                                        <div className="d-flex justify-content-end align-items-end mb-0 mt-2">
                                            <a href='NareshChandraDas_chairman'>
                                                <button className='cbsc_school mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                </svg></button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="album py-1">
                    <div className="container">
                        <div className="card mb-3" >
                            <div className="row g-0">
                                <div className="col-md-4">
                                    <img src={mramitavaguha_director} height="150px" width="150px" className="img-fluid  rounded-start" alt="mramitavaguha_director" />
                                </div>
                                <div className="col-md-8">
                                    <div className="card-body">
                                        <div className='welcometext'>
                                            <h5 className="card-title"><b>Message from the Director </b> </h5>

                                            <p className="card-text justify">It gives me immense pride and heartfelt joy to welcome you to <b>Krishnagar Public School</b>, the first CBSE school of Krishnagar. At KPS, we believe that education is not merely the acquisition of knowledge, but the transformation of young minds into confident, responsible and compassionate individuals. </p>
                                            <p className="card-text justify"><small className="text-muted mb-3">Our mission is to create a dynamic learning environment where academic excellence blends seamlessly with strong moral values and life skills. We are committed to nurturing curiosity, creativity and critical thinking, ensuring that every child discovers his or her unique potential and dares to dream big.
 </small></p>
                                        </div>
                                        <div className="d-flex justify-content-end align-items-end mb-0 mt-2">
                                            <a href='Mr.AmitavaGuha_director'>
                                                <button className='cbsc_school mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                </svg></button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="album py-1">
                    <div className="container">
                        <div className="card mb-3" >
                            <div className="row g-0">
                                <div className="col-md-4">
                                    <img src={drsankarprasaddutta_principal} height="150px" width="150px" className="img-fluid  rounded-start" alt="drsankarprasaddutta_principal" />
                                </div>
                                <div className="col-md-8">
                                    <div className="card-body">
                                        <div className='welcometext'>
                                            <h5 className="card-title"><b>Message from the Principal  </b> </h5>

                                            <p className="card-text justify">"Education is a shared commitment between dedicated teachers, motivated students and enthusiastic parents with high expectations." </p>
                                            <p className="card-text justify"><small className="text-muted mb-3">Today, the role of a school is not only to pursue academic excellence but also to motivate and empower its students to be lifelong learners, critical thinkers and productive members of an ever-changing global society. Few years back KPS Nadia pledged to transform education. The school that is being run under the aegis of well-established Management "National Centre for Development of Technical Education" has carved its own niche not only in the city but also across the nation. At Krishnagar Public School, we provide an atmosphere for multifaceted development, where children are encouraged to channelize their potential in the pursuit of excellence. We are a school with a difference. We value individualism, creativity and innovation and strive to nurture them in our students. </small></p>
                                        </div>
                                        <div className="d-flex justify-content-end align-items-end mb-0 mt-2">
                                            <a href='Dr.SankarPrasadDutta_Principal'>
                                                <button className='cbsc_school mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                </svg></button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
            </div>
            {/* 
            <div className='schooltiming'>
                <br />
                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 mt-3 ">
                                <h4 className='btn-grad17'>NOTICE BOARD <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="currentColor" class="bi bi-clipboard" viewBox="0 0 16 16">
                                    <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z" />
                                    <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z" />
                                </svg></h4>
                                <div className='colmnnew'>
                                    <div className="card-body ">

                                        <div className='welcometext'>
                                            <br />
                                            <NoticeBoard />


                                            <br />
                                            <br />

                                            <br />
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 mt-3 ">
                                <h4 className='btn-grad19'>UPCOMING EVENT HELD <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="currentColor" class="bi bi-calendar-event-fill" viewBox="0 0 16 16">
                                    <path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2m-3.5-7h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5" />
                                </svg></h4>
                                <div className='colmnback'>

                                    <div className="card-body">
                                        <div className='welcometext'>

                                            <br />
                                            <EventHeld />


                                            <br />
                                            <br />
                                            <br />




                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                </div>
                <br />
            </div> */}


            <div className="album py-0">
                <div className="container">
                    <div className="row">





                        <div className="col-md-6 mt-3">
                            <div className='cardmotation'>
                                <div className="card">
                                    <h4 className='btn-grad84'>NOTICE BOARD <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="currentColor" class="bi bi-clipboard" viewBox="0 0 16 16">
                                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z" />
                                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z" />
                                    </svg> </h4>

                                    <div className="card-body ">

                                        <div className='welcometext'>
                                            <br />
                                            <NoticeBoard />


                                            <br />
                                            <br />
                                            <br />

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>





                        <div className="col-md-6 mt-3">
                            <div className='cardmotation'>
                                <div className="card">
                                    <h4 className='btn-grad88'>UPCOMING EVENT HELD <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="currentColor" class="bi bi-calendar-event-fill" viewBox="0 0 16 16">
                                        <path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2m-3.5-7h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5" />
                                    </svg></h4>
                                    <div className="card-body">
                                        <div className='welcometext'>

                                            <br />
                                            <EventHeld />


                                            <br />
                                            <br />
                                            <br />




                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <br />
            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-5 mt-3 ">
                            <h4 className='btn-grad85'>IMPORTANT LINK <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="currentColor" class="bi bi-link" viewBox="0 0 16 16">
                                <path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9q-.13 0-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z" />
                                <path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4 4 0 0 1-.82 1H12a3 3 0 1 0 0-6z" />
                            </svg></h4>
                            <div className='colmnnewyellow'>
                                <div className="card-body">

                                    <div className='welcometext'>

                                        <div className="d-flex justify-content-start align-items-center mb-2">
                                            <a href='Co-scholastics'>
                                                <button className='buttonnew me-2 mt-2'><small>CO-SCHOLASTICS </small> </button>
                                            </a>
                                            <a href='NewRealites'>
                                                <button className='buttonnew mt-2'>NEW REALITIES </button>
                                            </a>
                                        </div>

                                        <div className="d-flex justify-content-start align-items-center mb-2">
                                            <a style={{ color: "white" }} href={kps_admissionform} className='' target="_blank" rel="noopener noreferrer">
                                                <button className='buttonnew me-2 mt-2'>ADMISSION FORM </button>
                                            </a>
                                            <a href='contactus'>
                                                <button className='buttonnew mt-2'>CONTACT </button>
                                            </a>
                                        </div>

                                        <a href='Awards-recognition'>
                                            <button className='buttonnew me-2 mb-1 mt-2'>AWARDS & RECOGNITION </button>
                                        </a>
                                        <a href='PressRelease'>
                                            <button className='buttonnew mt-2'>PRESS RELESE </button>
                                        </a>
                                        <a href='Agecriteria-forAdmisiion'>
                                            <button className='buttonnew mt-2 me-2'>AGE CRITARIA FOR ADMISSION </button>
                                        </a>
                                        <a href='facilities'>
                                            <button className='buttonnew mt-2'> FACILITIES </button>
                                        </a>
                                        <br />

                                        <br />
                                        <br />
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-7 mt-3">
                            <div className='colmnbackbutton'>
                                <div className="card-body">
                                    <div className='welcometext'>
                                        <button className='schooltime mb-3'><b>SCHOOL TIMING <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-alarm-fill" viewBox="0 0 16 16">
                                            <path d="M6 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H9v1.07a7.001 7.001 0 0 1 3.274 12.474l.601.602a.5.5 0 0 1-.707.708l-.746-.746A6.97 6.97 0 0 1 8 16a6.97 6.97 0 0 1-3.422-.892l-.746.746a.5.5 0 0 1-.707-.708l.602-.602A7.001 7.001 0 0 1 7 2.07V1h-.5A.5.5 0 0 1 6 .5m2.5 5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9zM.86 5.387A2.5 2.5 0 1 1 4.387 1.86 8.04 8.04 0 0 0 .86 5.387M11.613 1.86a2.5 2.5 0 1 1 3.527 3.527 8.04 8.04 0 0 0-3.527-3.527" />
                                        </svg></b></button>

                                        <p style={{ color: "#1D4D93" }} className="card-text mb-3"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar2-check" viewBox="0 0 16 16">
                                            <path d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                                            <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
                                        </svg> Working Days :  <small>Monday to Friday</small>  </p>
                                        <h5 style={{ color: "#009846" }} className="card-title mb-2"><b>Working Hours</b> </h5>
                                        <h6 style={{ color: "#1D4D93" }} >Student's Entry : 8:45 am</h6>
                                        <h6 style={{ color: "#1D4D93" }} >Playgroup to KG : 9:00 am to 12:05 pm </h6>
                                        <h6 style={{ color: "#1D4D93" }} >Classes I & II : 9:00 am to 12:45 pm  </h6>
                                        <h6 style={{ color: "#1D4D93" }} >Class II to X : 9:00 am to 3:00 pm </h6>
                                        <h6 className='' style={{ color: "#1D4D93" }} >Classes XI & XII
                                            : 9:00 am to 3:40 pm</h6>

                                    </div>
                                    <div className="d-flex justify-content-end align-items-end mb-0 mt-2">
                                        <a href='School&class-timing'>
                                            <button className='cbsc_school mt-1'>CLASS TIMING (Read More) <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                            </svg></button>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br />
                </div>
                <br />
            </div>
            <div className='videobaccolor'>
                <br />
                <div className="album py-0">
                    <div className="container">
                        <div className='welcometext'>
                            <h2><b>Video Gallery</b></h2>
                        </div>
                    </div>
                </div>

                <Vgallery />
                <br />


            </div>

            <br />
            <div className='socialmedia'>
                <br />
                <div className="album py-0">
                    <div className="container">
                        <div className='welcometext'>
                            <h2><b>Social Media <b>FACEBOOK</b></b></h2>
                        </div>
                    </div>
                </div>

                <div className="album py-2">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 mt-3">
                                <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FKPSVoices%2F&tabs=timeline&width=600&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="100%" height="500" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>


                            </div>
                            <div className="col-md-6 mt-3">
                                <iframe src="https://www.facebook.com/plugins/video.php?height=500&href=https%3A%2F%2Fwww.facebook.com%2FKPSVoices%2Fvideos%2F1242395007190393%2F&show_text=false&width=560&t=0" width="100%" height="500" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div className="album py-0">
                <div className="container">
                    <div className='welcometext'>
                        <h1><b>New Realities</b></h1>
                        <div className="col-md-3">
                            <hr style={{ color: "#1D4D93" }} />
                        </div>
                    </div>
                </div>
            </div>
            <NewRealites />
            <br />

        </div >
    )
}

export default Home